// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__V3_Ca"};